var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BeeModel } from "../../beeorm/BeeModel";
import { BeeModelManager } from "../../beeorm/BeeModelManager";
import { normalizeField } from "../../components/BookingFormPage/field-meta";
import { EntitiesEnum } from "../../store/store";
import { BillPositionModel } from "./BillPositions/BillPositionModel";
import { BillModel } from "./Bills/BillModel";
import { PaymentGatewayConfigModel } from "./PaymentGatewayConfigs/PaymentGatewayConfigModel";
import { differenceInDays } from "date-fns";
import i18next from "i18next";
import { componentTypes } from "../../components/Form/form-constants";
import has from "lodash/has";
import get from "lodash/get";
import filter from "lodash/filter";
import uniq from "lodash/uniq";
import assign from "lodash/assign";
import { BankModel } from "./Banks/BankModel";
import { currency } from "../../helpers";
import { dateFormat } from "../../helpers/date";
import { getBillIdKey } from "./helpers";
import { getPaybookEntities } from "../../store/actions/response.actions";
var PaymentModelManager = /** @class */ (function (_super) {
    __extends(PaymentModelManager, _super);
    function PaymentModelManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentModelManager.prototype.bills = function () {
        return this.getCollection('bills');
    };
    PaymentModelManager.prototype.billPositions = function () {
        return this.getCollection('bill_positions');
    };
    PaymentModelManager.prototype.banks = function () {
        return this.getCollection('banks');
    };
    PaymentModelManager.prototype.discounts = function () {
        return this.getCollection('discounts');
    };
    PaymentModelManager.prototype.paymentGatewayConfigs = function () {
        return this.getCollection('payment_gateway_configs');
    };
    PaymentModelManager.prototype.deriveForm = function (form, session_id) {
        var _a;
        if (session_id !== form.payment_session_id)
            form = {};
        var discountCode = (has(form, "coupon_code") ? form.coupon_code : (_a = this.discounts().first()) === null || _a === void 0 ? void 0 : _a.get("code")) || "";
        var defaultValue = this.options.default_payment_gateway_configs_online || "";
        var fixedBillIds = this.getFixedBills(+this.options.direct_pay_days).map(function (_a) {
            var id = _a.id;
            return id;
        });
        var defaultCheckedIds = this.getFixedBills(+this.options.default_payment_for_days).map(function (_a) {
            var id = _a.id;
            return id;
        });
        var selectedBillIds = filter(form.selected_bill_ids, "selected").map(function (_a) {
            var id = _a.id;
            return id;
        });
        var billIds = uniq((form.selected_bill_ids ? selectedBillIds : defaultCheckedIds).concat(fixedBillIds));
        var selected_bill_ids = this.bills().all().reduce(function (bills, _a) {
            var _b;
            var id = _a.id;
            assign(bills, (_b = {}, _b[getBillIdKey(id)] = {
                id: id,
                selected: billIds.includes(id)
            }, _b));
            return bills;
        }, {});
        return {
            coupon_code: discountCode,
            payment_session_id: session_id,
            payment_method: "" + (get(form, "payment_method") || defaultValue),
            selected_bill_ids: selected_bill_ids,
        };
    };
    PaymentModelManager.prototype.getPaymentForm = function (form) {
        var _a;
        if (form === void 0) { form = {}; }
        var bills = this.getBillFields(form);
        var paymentGateway = ((_a = filter(form.selected_bill_ids, "selected")) === null || _a === void 0 ? void 0 : _a.length) ? this.getGatewayFields(form) : null;
        var selectedBillIds = filter(form.selected_bill_ids, "selected").map(function (_a) {
            var id = _a.id;
            return id;
        });
        var sumTotals = this.bills().all().reduce(function (sum, bill) { return ({
            total: currency(sum.total).add(+bill.get("price")).value,
            totalNet: currency(sum.totalNet).add(+bill.get("net_price")).value,
            tax: currency(sum.tax).add(+bill.get("tax")).value,
        }); }, { total: 0, totalNet: 0, tax: 0 });
        var selectedTotal = this.bills().whereIn("id", selectedBillIds).all().reduce(function (sum, bill) { return ({
            total: currency(sum.total).add(+bill.get("price")).value,
            totalNet: currency(sum.totalNet).add(+bill.get("net_price")).value,
            tax: currency(sum.tax).add(+bill.get("tax")).value,
        }); }, { total: 0, totalNet: 0, tax: 0 });
        return {
            bills: bills,
            paymentGateway: paymentGateway,
            couponCode: this.getCouponCodeForm(form),
            total: currency(sumTotals.total).format(),
            totalNet: currency(sumTotals.totalNet).format(),
            tax: currency(sumTotals.tax).format(),
            selectedTotal: currency(selectedTotal.total).format(),
            selectedTotalNet: currency(selectedTotal.totalNet).format(),
            selectedTax: currency(selectedTotal.tax).format(),
        };
    };
    PaymentModelManager.prototype.getFixedBills = function (countDays) {
        if (countDays === void 0) { countDays = 0; }
        var now = new Date();
        return this.bills().filter(function (b) {
            var dueDate = new Date(b.get("due_date"));
            return differenceInDays(dueDate, now) < countDays;
        }).all();
    };
    PaymentModelManager.prototype.getBillFields = function (form) {
        var now = new Date();
        var dateFormatString = i18next.t('date.date_format');
        var directPayDays = +this.options.direct_pay_days;
        var hasGrossTax = +this.options.is_gross_tax;
        return this.bills().all().map(function (b, i) {
            var dueDate = new Date(b.get("due_date"));
            var payImmediately = differenceInDays(dueDate, now) < directPayDays;
            var id = b.get("id");
            var positions = b.billPositions().all().map(function (bp) { return ({
                title: bp.get("presented.title"),
                quantity: bp.get("quantity"),
                price: currency(+bp.get("single_price")).multiply(+bp.get("quantity")).format(),
                netPrice: currency(+bp.get("net_price")).multiply(+bp.get("quantity")).format()
            }); });
            var _a = hasGrossTax ? ["pay.due_now", "pay.due_on"] : ["pay.due_now_net", "pay.due_on_net"], dueNowKey = _a[0], dueOnKey = _a[1];
            var dueDateParams = {
                due_date: dateFormat(dueDate, dateFormatString),
                price: currency(b.get("price")).format(),
                netPrice: currency(b.get("net_price")).format(),
            };
            return normalizeField({
                name: "selected_bill_ids." + getBillIdKey(id) + ".selected",
                title: payImmediately ? i18next.t(dueNowKey, dueDateParams) : i18next.t(dueOnKey, dueDateParams),
                field_type_name: componentTypes.PRICE_SELECT,
            }, {
                disabled: payImmediately,
                positions: positions,
            });
        });
    };
    PaymentModelManager.prototype.getGatewayFields = function (form) {
        var initialValue = get(form, "payment_method", "");
        var defaultValue = this.options.default_payment_gateway_configs_online || "";
        var selectedValue = "" + (initialValue || defaultValue);
        var selectedBills = filter(form.selected_bill_ids, "selected").map(function (_a) {
            var id = _a.id;
            return id;
        });
        var required = this.bills().whereIn("id", selectedBills).all().reduce(function (sum, bill) { return sum + +bill.get("price"); }, 0) > 0;
        var gateways = this.paymentGatewayConfigs().all().map(function (g) {
            return normalizeField({
                name: "payment_method",
                title: g.get("online_title"),
                field_type_name: componentTypes.PAYMENT_GATEWAY_RADIO,
                is_required: required,
            }, {
                is_recommended: !!g.get("is_recommended"),
                value: +g.get("id"),
                image_url: g.get("url"),
                initialValue: selectedValue,
                description: g.get("description"),
                checked: ("" + g.get("id")) === selectedValue,
            });
        });
        return {
            name: "payment_gateway",
            component: componentTypes.PAYMENT_GATEWAY,
            fields: gateways
        };
    };
    PaymentModelManager.prototype.getCouponCodeForm = function (form) {
        return {
            minLength: 3,
            name: "coupon_code",
            shouldDispatch: true,
            component: componentTypes.COUPON_CODE,
            label: i18next.t("paybook.coupon_code.title"),
            placeholder: i18next.t("paybook.coupon_code.placeholder"),
            coupon_code_apply: i18next.t("common.apply"),
            hasError: this.options.hasError,
            discountCodeStatus: this.options.discountStatus,
            onSubmit: function (couponCode, remove) { return function (dispatch) {
                return dispatch(getPaybookEntities(form === null || form === void 0 ? void 0 : form.payment_session_id, false, couponCode || undefined, remove));
            }; },
        };
    };
    return PaymentModelManager;
}(BeeModelManager));
export { PaymentModelManager };
export var getPaymentManager = function (entities, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var modelTypes = (_a = {},
        _a[EntitiesEnum.BILLS] = BillModel,
        _a[EntitiesEnum.BILL_POSITIONS] = BillPositionModel,
        _a[EntitiesEnum.PAYMENT_GATEWAY_CONFIGS] = PaymentGatewayConfigModel,
        _a[EntitiesEnum.BANKS] = BankModel,
        _a[EntitiesEnum.DISCOUNTS] = BeeModel,
        _a);
    return new PaymentModelManager(modelTypes, entities, options);
};
